import React from 'react'
import SelectBox from '../common/SelectBox'
import InputBox from 'containers/common/components/InputBox'
import AddressLookup from 'components/Lookups/Address'

import ResidentialStatus from './ResidentialStatus'
import SellingHome from './SellingHome'
import HomeWorth from './HomeWorth'
import RentWorth from './RentWorth'

import GenericIcon from 'components/GenericIcon'

class CurrentHome extends React.Component {
  render() {
    const { errors,
            residentialStatus,
            sellCurrentHome,
            currentHomeWorth,
            currentHomeRentWorth,
            currentHomeRentFrequency,
            handleResidentialStatus,
            handleSellCurrentHome,
            handleCurrentHomeRentFrequency,
            handleCurrentHomeWorth,
            handleCurrentHomeFullAddress,
            currentHomeFullAddress,
            disabled,
          } = this.props

    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <GenericIcon name='currentHome' />
          </div>
          Your current home
        </div>
        <div className='card-body'>
          <ResidentialStatus
            disabled={ disabled }
            checked={ residentialStatus }
            onChange={ handleResidentialStatus }
          />
          {
            residentialStatus === 'own' && (
              <div>
                <SellingHome
                  disabled={ disabled }
                  checked={ sellCurrentHome }
                  onChange={ handleSellCurrentHome }
                />
                <HomeWorth
                  disabled={ disabled }
                  value={ currentHomeWorth }
                  onChange={ handleCurrentHomeWorth }
                  errorMessage={ errors['currentHomeWorth'] }
                />
                {
                  sellCurrentHome &&
                    <AddressLookup
                      inputGroupClass='w-100'
                      label='What is the address of the property?'
                      placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'
                      defaultValue={ currentHomeFullAddress }
                      onChange={ (result) => { handleCurrentHomeFullAddress(result) } }
                      errorMessage={ errors['currentHomeFullAddress'] }
                    />
                }
                {
                  !sellCurrentHome &&
                    <RentWorth
                      disabled={ disabled }
                      value={ currentHomeRentWorth }
                      onChange={ handleCurrentHomeWorth }
                      errorMessage={ errors['currentHomeRentWorth'] }
                      frequencyValue={ currentHomeRentFrequency }
                      onFrequencyChange={ handleCurrentHomeRentFrequency }
                    />
                }
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default CurrentHome;
